import { Controller } from "@hotwired/stimulus"

// Fetches options from a URL when a source select changes, populates a target element.
// Usage:
//   data-controller="remote-select"
//   data-remote-select-url-value="/blocks/select_options"
//   data-remote-select-param-value="farm_id"
//   data-remote-select-target-id-value="block_id"
//   data-remote-select-extra-params-value='{"other_id": "123"}'  (optional)
//   data-action="change->remote-select#load"

export default class extends Controller {
  static values = {
    url: String,
    param: String,
    targetId: String,
    extraParams: { type: Object, default: {} }
  }

  async load() {
    const value = this.element.value
    if (!value) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, value)

    Object.entries(this.extraParamsValue).forEach(([k, v]) => {
      url.searchParams.set(k, v)
    })

    // Also collect values from named sibling selects if specified
    const siblingIds = this.data.has("sibling-ids") ? JSON.parse(this.data.get("sibling-ids")) : []
    siblingIds.forEach(id => {
      const el = document.getElementById(id)
      if (el && el.value) url.searchParams.set(el.dataset.param, el.value)
    })

    const response = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
    const html = await response.text()
    document.getElementById(this.targetIdValue).innerHTML = html
  }
}
